import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const ConversationHistory = ({ history = [], endRef }) => (
  <Paper
    elevation={0}
    sx={{
      p: { xs: 1.25, sm: 2 },
      borderRadius: { xs: 2.5, md: 3 },
      height: '100%',
      border: '1px solid',
      borderColor: 'divider',
      background: 'rgba(255,255,255,0.72)',
      backdropFilter: 'blur(10px)',
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: 950, mb: { xs: 1, md: 1.5 }, color: '#173525', fontSize: { xs: '1rem', sm: '1.25rem' } }}>
      رحلة مشروبك
    </Typography>

    <Box sx={{ maxHeight: { xs: 280, sm: 360, md: 620 }, overflowY: 'auto', pr: 0.5 }}>
      {history.length ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
          {history.map((entry) => {
            const isUser = entry.role === 'user';

            return (
              <Box
                key={entry.id}
                sx={{
                  display: 'flex',
                  justifyContent: isUser ? 'flex-start' : 'flex-end',
                }}
              >
                <Box
                  sx={(theme) => ({
                    width: '100%',
                    p: 1.35,
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: isUser
                      ? alpha(theme.palette.primary.main, 0.18)
                      : alpha(theme.palette.secondary.main, 0.18),
                    background: isUser
                      ? alpha(theme.palette.primary.main, 0.07)
                      : alpha(theme.palette.secondary.main, 0.07),
                  })}
                >
                  <Typography variant="caption" sx={{ display: 'block', mb: 0.35, fontWeight: 950, color: 'text.secondary' }}>
                    {isUser ? 'أنت' : 'Nuvvy'}
                  </Typography>
                  <Typography sx={{ whiteSpace: 'pre-line', lineHeight: 1.75, fontWeight: 700 }}>
                    {entry.text}
                  </Typography>
                </Box>
              </Box>
            );
          })}
          <span ref={endRef} />
        </Box>
      ) : (
        <Box
          sx={{
            minHeight: 180,
            display: 'grid',
            placeItems: 'center',
            textAlign: 'center',
            color: 'text.secondary',
            border: '1px dashed',
            borderColor: 'divider',
            borderRadius: 2,
            px: 2,
          }}
        >
          <Typography variant="body2" sx={{ lineHeight: 1.8, fontSize: { xs: '0.84rem', sm: '0.875rem' } }}>
            هنا هتظهر الأسئلة والإجابات بالترتيب أثناء رحلة تصميم المشروب.
          </Typography>
        </Box>
      )}
    </Box>
  </Paper>
);

export default ConversationHistory;
